// The access token lives in module memory only, so an XSS payload can't read
// it out of localStorage. A page load or new tab restores it by exchanging the
// httpOnly rl_refresh cookie (see silentRefresh in user_context.jsx).
let accessToken = null;

export const getToken = () => accessToken;
export const setToken = (token) => { accessToken = token || null; };
export const clearToken = () => { accessToken = null; };
